import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const getCurrent = async () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.current}`);
};

export const fetchUsers = async () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.user}`);
};

export const addUser = async user => {
  const instance = getAxiosInstance();
  return instance.post(`${config.baseUrl}${config.paths.user}`, user);
};

export const editUser = async user => {
  const instance = getAxiosInstance();
  return instance.put(`${config.baseUrl}${config.paths.user}/${user.id}`, user);
};

export const deleteUser = async user => {
  const instance = getAxiosInstance();
  return instance.delete(`${config.baseUrl}${config.paths.user}/${user.id}`);
};

export default {
  getCurrent,
  fetchUsers,
  addUser,
  editUser,
  deleteUser
};
